import { useEffect, useState } from "react";

/**
 * The phone layout switch. At viewport widths of 640px and below the cockpit
 * renders the owner-approved phone layout (mockups/cockpit-v3/mobile/); at
 * 641px and above it renders the desktop layout, unchanged. One breakpoint,
 * decided in JavaScript so the two layouts never share (or double) the DOM.
 */
export const PHONE_MAX_WIDTH = 640;
export const PHONE_QUERY = `(max-width: ${PHONE_MAX_WIDTH}px)`;

/** True when `win` (default: the browser window) is phone width. False with no window (server rendering). */
export function isPhoneViewport(win = typeof window !== "undefined" ? window : null) {
  if (!win || typeof win.matchMedia !== "function") return false;
  return Boolean(win.matchMedia(PHONE_QUERY).matches);
}

/** Subscribes to the breakpoint; returns true while the viewport is phone width. */
export function usePhone() {
  const [phone, setPhone] = useState(() => isPhoneViewport());
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return undefined;
    const query = window.matchMedia(PHONE_QUERY);
    const onChange = () => setPhone(Boolean(query.matches));
    onChange();
    if (typeof query.addEventListener === "function") {
      query.addEventListener("change", onChange);
      return () => query.removeEventListener("change", onChange);
    }
    query.addListener(onChange);
    return () => query.removeListener(onChange);
  }, []);
  return phone;
}
